import { graphql } from "../../gql";

// changedAt is declared by every mutation and set by changedAtExchange (ADR-11)

export const playlistFieldsFragment = graphql(`
  fragment PlaylistFields on PlaylistUB {
    id
    title
    belongsToCrew
    tags
    createdAt
    updatedAt
    items {
      id
      position
      songId
      title
      note
    }
  }
`);

export const playlistsIdsQuery = graphql(`
  query playlistsIdsQuery {
    playlists {
      id
    }
  }
`);

export const playlistsDeltaQuery = graphql(`
  query playlistsDeltaQuery($updatedSince: OffsetDateTime) {
    playlists(updatedSince: $updatedSince) {
      ...PlaylistFields
    }
  }
`);

export const playlistsFullQuery = graphql(`
  query playlistsFullQuery {
    playlists {
      ...PlaylistFields
    }
  }
`);

export const createPlaylistMutation = graphql(`
  mutation createPlaylistMutation(
    $id: ID!
    $title: String!
    $crewId: ID
    $tags: [String!]!
    $items: [PlaylistItemInput!]!
    $changedAt: OffsetDateTime!
  ) {
    createPlaylist(
      id: $id
      title: $title
      crewId: $crewId
      tags: $tags
      items: $items
      changedAt: $changedAt
    ) {
      ...PlaylistFields
    }
  }
`);

export const renamePlaylistMutation = graphql(`
  mutation renamePlaylistMutation(
    $id: ID!
    $title: String!
    $changedAt: OffsetDateTime!
  ) {
    renamePlaylist(id: $id, title: $title, changedAt: $changedAt) {
      ...PlaylistFields
    }
  }
`);

export const setPlaylistTagsMutation = graphql(`
  mutation setPlaylistTagsMutation(
    $id: ID!
    $tags: [String!]!
    $changedAt: OffsetDateTime!
  ) {
    setPlaylistTags(id: $id, tags: $tags, changedAt: $changedAt) {
      ...PlaylistFields
    }
  }
`);

export const assignPlaylistToCrewMutation = graphql(`
  mutation assignPlaylistToCrewMutation(
    $id: ID!
    $crewId: ID
    $changedAt: OffsetDateTime!
  ) {
    assignPlaylistToCrew(id: $id, crewId: $crewId, changedAt: $changedAt) {
      ...PlaylistFields
    }
  }
`);

export const deletePlaylistMutation = graphql(`
  mutation deletePlaylistMutation($id: ID!, $changedAt: OffsetDateTime!) {
    deletePlaylist(id: $id, changedAt: $changedAt) {
      ...PlaylistFields
    }
  }
`);

export const addPlaylistItemMutation = graphql(`
  mutation addPlaylistItemMutation(
    $id: ID!
    $item: PlaylistItemInput!
    $changedAt: OffsetDateTime!
  ) {
    addPlaylistItem(id: $id, item: $item, changedAt: $changedAt) {
      ...PlaylistFields
    }
  }
`);

export const movePlaylistItemMutation = graphql(`
  mutation movePlaylistItemMutation(
    $id: ID!
    $itemId: ID!
    $position: String!
    $changedAt: OffsetDateTime!
  ) {
    movePlaylistItem(
      id: $id
      itemId: $itemId
      position: $position
      changedAt: $changedAt
    ) {
      ...PlaylistFields
    }
  }
`);

export const setPlaylistItemTitleMutation = graphql(`
  mutation setPlaylistItemTitleMutation(
    $id: ID!
    $itemId: ID!
    $title: String
    $changedAt: OffsetDateTime!
  ) {
    setPlaylistItemTitle(
      id: $id
      itemId: $itemId
      title: $title
      changedAt: $changedAt
    ) {
      ...PlaylistFields
    }
  }
`);

export const setPlaylistItemNoteMutation = graphql(`
  mutation setPlaylistItemNoteMutation(
    $id: ID!
    $itemId: ID!
    $note: String
    $changedAt: OffsetDateTime!
  ) {
    setPlaylistItemNote(
      id: $id
      itemId: $itemId
      note: $note
      changedAt: $changedAt
    ) {
      ...PlaylistFields
    }
  }
`);

export const removePlaylistItemMutation = graphql(`
  mutation removePlaylistItemMutation(
    $id: ID!
    $itemId: ID!
    $changedAt: OffsetDateTime!
  ) {
    removePlaylistItem(id: $id, itemId: $itemId, changedAt: $changedAt) {
      ...PlaylistFields
    }
  }
`);
